"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _resizeObserverPolyfill = _interopRequireDefault(require("resize-observer-polyfill"));

var _useDebounce = require("use-debounce");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
/**
 * Capture size of an element
 *  with help of [ResizeObserver](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver)
 */


var useSize = function useSize() {
  var debounce = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var ref = (0, _react.useRef)();

  var _useState = (0, _react.useState)({
    height: 0,
    width: 0
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      size = _useState2[0],
      setSize = _useState2[1];

  var _useDebouncedCallback = (0, _useDebounce.useDebouncedCallback)(function (s) {
    return setSize(s);
  }, debounce, {
    maxWait: 250
  }),
      _useDebouncedCallback2 = (0, _slicedToArray2["default"])(_useDebouncedCallback, 1),
      handleSetSize = _useDebouncedCallback2[0];
  /**
   * Make an instance of ResizeObserver
   */


  var ro = (0, _react.useMemo)(function () {
    return new _resizeObserverPolyfill["default"](function (entries) {
      if (entries.length > 0) {
        var entry = entries[0];

        var _entry$target$getBoun = entry.target.getBoundingClientRect(),
            _entry$target$getBoun2 = _entry$target$getBoun.height,
            height = _entry$target$getBoun2 === void 0 ? 0 : _entry$target$getBoun2,
            _entry$target$getBoun3 = _entry$target$getBoun.width,
            width = _entry$target$getBoun3 === void 0 ? 0 : _entry$target$getBoun3;

        handleSetSize({
          height: height,
          width: width
        });
      }
    });
  }, [setSize]);
  /**
   * Capture ref and start listening here
   */

  var captureRef = (0, _react.useCallback)(function (e) {
    if (ref.current !== e) {
      if (ref.current) {
        ro.unobserve(ref.current);
      }

      ref.current = e;

      if (e && (0, _typeof2["default"])(e) === 'object') {
        var _e$getBoundingClientR = e.getBoundingClientRect(),
            _e$getBoundingClientR2 = _e$getBoundingClientR.height,
            height = _e$getBoundingClientR2 === void 0 ? 0 : _e$getBoundingClientR2,
            _e$getBoundingClientR3 = _e$getBoundingClientR.width,
            width = _e$getBoundingClientR3 === void 0 ? 0 : _e$getBoundingClientR3;

        setSize({
          height: height,
          width: width
        });
        ro.observe(e);
      }
    }
  }, [ro]); // Cleanup all before exit

  (0, _react.useEffect)(function () {
    return function () {
      return ro.disconnect();
    };
  }, []);
  return [size, captureRef, ref];
};

__signature__(useSize, "useRef{ref}\nuseState{[size, setSize]({ height: 0, width: 0 })}\nuseDebouncedCallback{[handleSetSize]}\nuseMemo{ro}\nuseCallback{captureRef}\nuseEffect{}", function () {
  return [_useDebounce.useDebouncedCallback];
});

var _default = useSize;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useSize, "useSize", "/builds/bA1zbJom/0/gojob/ui-bits/src/hooks/useSize.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/hooks/useSize.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();